import React, { useState } from "react";

const reviews = [
  { name: "Naveen K.", role: "Buyers' Agent", city: "Melbourne", image: "/Naveenreview.png" },
  { name: "Mohan P.", role: "Buyers' Agent", city: "Melbourne", image: "/Mohanreview.png" },
  { name: "Vera W.", role: "Buyers' Agent", city: "Melbourne", image: "/Verareview.png" },
  { name: "Tim F.", role: "Buyers' Agent", city: "Sydney", image: "/Timreview.png" },
  { name: "Richard T.", role: "Buyers' Agent", city: "Sydney", image: "/Richardreview.png" },
  { name: "Guru S.", role: "Buyers' Agent", city: "Brisbane", image: "/Gurureview.png" },
  { name: "Arpit S.", role: "Buyers' Agent", city: "Melbourne", image: "/Arpitreview.png" },
];

const BuyersAgentReviewSection = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="bg-[#f3f4f6] p-8 rounded-xl mb-8">
      <h2 className="text-2xl md:text-3xl font-semibold text-[#003366] mb-6">
        What Buyers' Agents Are Saying About Propsourcing™
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <button
            key={r.name}
            onClick={() => setActive(i)}
            className="group text-left bg-white rounded-xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl hover:-translate-y-0.5 transition"
          >
            {/* Screenshot */}
            <img
              src={r.image}
              alt={`Review from ${r.name}, ${r.city}`}
              loading="lazy"
              className="w-full h-auto object-cover"
            />
            {/* Caption */}
            <div className="px-4 py-3 border-t bg-white">
              <p className="font-semibold text-[#003366]">{r.name}</p>
              <p className="text-xs text-gray-500">{r.city}</p>
            </div>
          </button>
        ))}
      </div>

      {/* Lightbox modal */}
      {active !== null && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
          onClick={() => setActive(null)}
        >
          <img
            src={reviews[active].image}
            alt={`Review from ${reviews[active].name}, ${reviews[active].city}`}
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </section>
  );
};

export default BuyersAgentReviewSection;
